import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Phone, MapPin, Mail, MessageCircle } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/settings").then((r) => setS(r.data)).catch(() => {}); }, []);
  const b = s?.business || {};
  return (
    <footer className="mt-24 border-t border-amber-500/15 bg-[#07070A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 grid gap-10 md:grid-cols-4">
        <div>
          <Logo />
          <p className="mt-4 text-sm text-zinc-400 max-w-xs">
            Fine dining and restful stays in the heart of Besham.
            Order your favourites online or reserve your room.
          </p>
        </div>
        <div>
          <h4 className="font-serif text-lg text-amber-200 mb-3">Contact</h4>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li className="flex gap-2 items-start"><Phone size={14} className="mt-1 text-amber-400" /> {b.phone || "TO BE PROVIDED"}</li>
            <li className="flex gap-2 items-start"><MessageCircle size={14} className="mt-1 text-amber-400" /> {b.whatsapp || "TO BE PROVIDED"}</li>
            <li className="flex gap-2 items-start"><Mail size={14} className="mt-1 text-amber-400" /> {b.email}</li>
            <li className="flex gap-2 items-start"><MapPin size={14} className="mt-1 text-amber-400" /> {b.address}</li>
          </ul>
        </div>
        <div>
          <h4 className="font-serif text-lg text-amber-200 mb-3">Hours</h4>
          <p className="text-sm text-zinc-300">{b.hours || "TO BE PROVIDED"}</p>
        </div>
        <div>
          <h4 className="font-serif text-lg text-amber-200 mb-3">Explore</h4>
          <ul className="space-y-2 text-sm">
            <li><a className="text-zinc-300 hover:text-amber-200" href="/menu">Full Menu</a></li>
            <li><a className="text-zinc-300 hover:text-amber-200" href="/rooms">Book a Room</a></li>
            <li><a className="text-zinc-300 hover:text-amber-200" href="/track">Track Order</a></li>
          </ul>
        </div>
      </div>
      <div className="divider-gold" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 text-xs text-zinc-500 flex flex-col sm:flex-row sm:justify-between gap-2">
        <div>© {new Date().getFullYear()} Moon Hotel & Restaurant · Besham, Pakistan</div>
        <div className="font-mono tracking-widest text-[10px] uppercase">Crafted with care</div>
      </div>
    </footer>
  );
}
